import React from 'react';
import { PageHeader } from 'antd';
import history from '@utils/history';
import { CouponForm } from '@containers/coupons';

function CreateCouponPage() {
  return (
    <div className="coupons main-page">
      <PageHeader
        title="New Coupon"
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
        onBack={() => history.goBack()}
      />
      <div className="main-content">
        <CouponForm />
      </div>
    </div>
  );
}

export default CreateCouponPage;
